// extracted by mini-css-extract-plugin
export default {"wrapper":"Bcko","header":"TJs0","title-message":"cbvT","titleMessage":"cbvT","change-location":"xQ4j","changeLocation":"xQ4j","map-widget":"VUxQ","mapWidget":"VUxQ"};